import { render, staticRenderFns } from "./v-dialog.vue?vue&type=template&id=bd5e72ac&scoped=true&"
import script from "./v-dialog.vue?vue&type=script&lang=js&"
export * from "./v-dialog.vue?vue&type=script&lang=js&"
import style0 from "./v-dialog.vue?vue&type=style&index=0&id=bd5e72ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5e72ac",
  null
  
)

export default component.exports